"use strict";
exports.__esModule = true;
exports.getGlobalObjectProperty = void 0;
var globalObjects = {
    Array: Array,
    Boolean: Boolean,
    Date: Date,
    Math: Math,
    Number: Number,
    String: String
};
var getGlobalObjectProperty = function (name, object) {
    if (name in globalObjects) {
        return globalObjects[name];
    }
    if (Object.values(globalObjects).includes(object)) {
        var property = object[name];
        if (!property) {
            throw new Error("undefinedFunction ".concat(name));
        }
        return property;
    }
    return null;
};
exports.getGlobalObjectProperty = getGlobalObjectProperty;
//# sourceMappingURL=global.js.map